<template>
  <div class="flex-auto cart_empty t_center" v-if="isEmptyCart">
    <img src="./images/cart_empty.png" alt="" />
    <p class="gray_2 f12_rem">进货车是空的</p>
    <div class="toBuy b_red white">
      <a class="white" href="JavaScript:;" @click="toWxIndex">去逛逛</a>
    </div>
  </div>
  <van-pull-refresh v-else v-model="refreshLoading" @refresh="onRefresh">
    <div class="cart h100-full">
      <div class="mui-content gray_2 h100-full flex flex-column">
        <div class="clear cart_head" v-if="cartList.length > 0">
          <div class="float-left">
            <a class="gray_2" href="https://dwz.nxin.com/1IXMyM">反馈</a>
            <!--<a class="gray_2 pad15_l" href="/mob/cart/cartInfoList.do?isNew=1">返回旧版</a>-->
          </div>
          <span class="float-right cart_edit" data-opt="edit" @click="editCart" v-show="!isEdit">编辑</span>
          <span class="float-right cart_edit" data-opt="edit" @click="editCart" v-show="isEdit">完成</span>
        </div>
        <div class="flex-auto pad15-lr overflow-auto" v-if="!isEmptyCart">
          <ul class="good_list">
            <li v-for="(cart, cartIndex) in cartList" v-bind:key="cart.shop.shopIdStr">
              <div class="cart_shop pad10-l pad15_r">
                <div class="relative float-left cart_shop_main">
                  <span class="d_dtit z_check " :class="{ cur: cart.isCheck }" @click="checkShop(cart)"></span>
                  <span class="f10_rem shop_label t_center red" v-if="cart.isSelfOperated">直营</span>
                  <img src="./images/shop.png" class="wh20 mar5-r" />
                  <a :href="`${taaspublicLink}?shopId=${cart.shop.shopIdStr}`"><span class="f15_rem fb">{{
                      cart.shop.shopName }}</span></a>
                </div>
              </div>
              <div v-for="(cartGoods, cartGoodsIndex) in cart.shopCartGoods" :key="cartGoods.cgId">
                <van-swipe-cell>
                  <van-divider v-if="cartGoodsIndex != 0" style="margin: 1px 15px" />
                  <div class="mui-slider-handle clear relative cart_good">
                    <div class="clear f10_rem lin_24" v-if="
                        cartGoods.promotionEntityVo != null &&
                          cartGoods.promotionEntityVo.promotionTypeCN != null
                      ">
                      <div class="float-left">
                        <span class="good_label b_red white">{{
                          cartGoods.promotionEntityVo.promotionTypeCN
                          }}</span>
                        <span v-if="
                            cartGoods.promotionEntityVo.promotionType != null &&
                              cartGoods.promotionEntityVo.promotionType === 'BUY_GIFTS'
                          ">
                          {{cartGoods.promotionEntityVo.promotionName}},
                          <span v-for="(item, index) in cartGoods.promotionEntityVo.giftList" :key="item.giftGoodsId">
                            {{item.promotionName}}
                            <template v-if="index != cartGoods.promotionEntityVo.giftList.length-1">、</template>
                          </span>
                          <!-- 活动商品{{ cartGoods.promotionEntityVo.promotionName }}，每人最多领取{{
                            cartGoods.promotionEntityVo.promotionLimitation
                          }}件赠品 -->
                        </span>
                        <span v-if="
                            cartGoods.promotionEntityVo.promotionTypeCN != null &&
                              cartGoods.promotionEntityVo.promotionTypeCN != '买赠' &&
                              cartGoods.promotionEntityVo.promotionTypeCN != '集采'
                          ">活动商品{{ cartGoods.promotionEntityVo.promotionName }}，每人限购{{
                          cartGoods.promotionEntityVo.promotionLimitation
                          }}件</span>
                        <span v-else-if="
                            cartGoods.promotionEntityVo.promotionTypeCN != null &&
                            cartGoods.promotionEntityVo.promotionTypeCN == '集采'
                        ">活动商品正在进行集采</span>
                      </div>
                    </div>
                    <div class="box5"></div>
                    <div class="cart_good_lose" v-if="cartGoods.isValid === 0">
                      <p>失效</p>
                    </div>
                    <div class="clear">
                      <div class="z_check float-left" v-if="cartGoods.isValid === 1" :class="{ cur: cartGoods.isCheck }"
                        @click="checkGoods(cart, cartGoods)"></div>
                      <div class="float-left" style="width: 25px; height: 100px;" v-else></div>
                      <!--                  <a :href="`/mob/goods/detail/`+ cartGoods.goodsId +`?fromShopId=`+ cartGoods.shopIdStr"><img class="float-left cart_good_img" :src="`${cartGoods.picUrl}?imageView2/1/w/65/h/65`"></a>-->
                      <a :href="
                          `/mob/goods/detail/` +
                            cartGoods.goodsId +
                            `?fromShopId=` +
                            cartGoods.shopIdStr
                        " class="float-left relative cart_good_img">
                        <div v-if="cartGoods.subscriptList && cartGoods.subscriptList.length"
                          class="absolute z-index2 goods-badge">
                          <img v-if="cartGoods.subscriptList[0].code == 'ZL_YH'"
                            src="https://nfs.nxin.com/cms_image_b7007a5b-168c-4e50-9721-eec66d6cf7e5.png" />
                          <img v-else-if="cartGoods.subscriptList[0].code == 'BP'"
                            src="https://nfs.nxin.com/cms_image_4a4b45d9-58b1-49b0-89ee-7a03f91b5225.png" />
                          <img v-else-if="cartGoods.subscriptList[0].code == 'YX'"
                            src="https://nfs.nxin.com/cms_image_b6ee03a9-cb9e-4023-8a72-63c85b4aff5a.png" />
                        </div>
                        <van-image lazy-load :src="`${cartGoods.picUrl}?imageView2/1/w/200/h/200`"></van-image>
                      </a>
                      <div class="float-left cart_good_main">
                        <a :href="
                            `/mob/goods/detail/` +
                              cartGoods.goodsId +
                              `?fromShopId=` +
                              cartGoods.shopIdStr
                          ">
                          <p class="gray_2 ellipsis_two f14_rem lin_20">
                            <!-- <span class="cart_good_vip f10_rem" v-if="cartGoods.isVip === 1">VIP</span> -->
                            <img class="h15 mar5-r" v-if="cartGoods.isShowFarmersDayLabel"
                              src="https://nfs.nxin.com/cms_image_546d8af9-8df0-47d0-8fe7-df4e51e209e7.png" />
                            <img class="h15 mar5-r" v-if="cartGoods.goodsPriceMemberLevel == '1'"
                              src="https://nfs.nxin.com/cms_image_b240a2d2-16f7-4373-bbf2-ad5c174955a5.png" />
                            <img class="h15 mar5-r" v-else-if="cartGoods.goodsPriceMemberLevel == '2'"
                              src="https://nfs.nxin.com/cms_image_e64adf1d-9f33-4fb8-a76f-411d131b0a15.png" />
                            <img class="h15 mar5-r" v-else-if="cartGoods.goodsPriceMemberLevel == '3'"
                              src="https://nfs.nxin.com/cms_image_288fce89-a676-4fb3-abe7-edf328256bcb.png" />
                            <img class="h15 mar5-r" v-else-if="cartGoods.goodsPriceMemberLevel == '4'"
                              src="https://nfs.nxin.com/cms_image_cd497405-898c-43c0-8aa2-c40f5e74d9ce.png" />
                            <img class="h15 mar5-r" v-else-if="cartGoods.goodsPriceMemberLevel == '5'"
                              src="https://nfs.nxin.com/cms_image_75a61308-16b4-4c17-bd51-f1840f4bb869.png" />
                            {{ cartGoods.goodsName }}
                          </p>
                          <div class="box5"></div>

                          <p class="f10_rem cart_good_spec" v-if="cartGoods.msUnit && cartGoods.msUnit.length > 0">
                            {{ cartGoods.unitConver }}{{ cartGoods.msUnit }}
                          </p>
                          <p class="f10_rem cart_good_spec" v-else>{{ cartGoods.goodsSpec }}</p>
                        </a>
                        <div class="box5"></div>
                        <template v-if="
                            cartGoods.goodsPriceEntity &&
                              cartGoods.goodsPriceEntity.commonLaddersPrice &&
                              cartGoods.goodsPriceEntity.commonLaddersPrice.goodsPriceList &&
                              cartGoods.goodsPriceEntity.commonLaddersPrice.goodsPriceList.length &&
                              cartGoods.goodsPriceEntity.commonLaddersPrice.laddersPriceMsg
                          ">
                          <div class="inline-block f24 ladders-price-msg">
                            {{ cartGoods.goodsPriceEntity.commonLaddersPrice.laddersPriceMsg }}
                          </div>
                          <div class="box5"></div>
                        </template>
                        <div class="clear" v-if="cartGoods.isValid === 1">
                          <div class="float-left" v-if="cartGoods.sellFactPriceStr != null">
                            <span class="f14_rem gray_2 price"><span class="fb">￥</span><em class="f20_rem">{{
                                cartGoods.sellFactPriceStr.split(".")[0]
                                }}</em>.{{ cartGoods.sellFactPriceStr.split(".")[1] }}</span>
                            <!--<p class="f12_rem gray_2 c_c7 t_through lin_15" v-if="cartGoods.sellPriceStr != null && cartGoods.sellPriceStr != cartGoods.sellFactPriceStr">￥{{cartGoods.sellPriceStr}}</p>-->
                          </div>
                          <div class="mui-pull-right">
                            <div class="box5"></div>
                            <!-- async-change -->
                            <van-stepper v-if="cartGoods.goodsDigit === 0" integer v-model="cartGoods.goodsQuantity"
                              :min="0" :max="99999999" input-width="60px" button-size="20px"
                              @change="quantityChange(cartGoods)" @focus="popQuantity(cartGoods, $event)"
                              @plus="plusQuantity(cartGoods)" @minus="minusQuantity(cartGoods)" />
                            <van-stepper v-else-if="quantityCartGoods.goodsDigit === 2"
                              v-model="cartGoods.goodsQuantity" :min="0" :max="99999999" input-width="60px"
                              button-size="20px" @change="quantityChange(cartGoods)"
                              @focus="popQuantity(cartGoods, $event)" @plus="plusQuantity(cartGoods)"
                              @minus="minusQuantity(cartGoods)" />
                            <van-stepper v-else v-model="cartGoods.goodsQuantity" :min="0" :max="99999999"
                              input-width="60px" button-size="20px" @change="quantityChange(cartGoods)"
                              @focus="popQuantity(cartGoods, $event)" @plus="plusQuantity(cartGoods)"
                              @minus="minusQuantity(cartGoods)" />
                            <div class="gray9 f10 pad5-t text-center"
                              v-if="cartGoods.minOrderQuantity && cartGoods.minOrderQuantity > 0">
                              {{ cartGoods.minOrderQuantity }}{{ cartGoods.mUnitCn }}起订
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="gray_2 f10_rem" v-if="cartGoods.isValid === 0">
                      <div class="box10"></div>
                      <i class="iconfont icon-shibai red fb mar5_r"></i>
                      货品未上架、库存不足会导致货品失效
                    </div>
                  </div>
                  <template #right>
                    <van-button square text="收藏" type="warning" style="height: 100%;" @click="addFavorite(cartGoods)"
                      v-if="cartGoods.isFavorite === 0 && cartGoods.isValid === 1" />
                    <van-button text="已收藏" type="warning" style="height: 100%;; width: 60px;"
                      @click="delFavorite(cartGoods)" v-if="cartGoods.isFavorite === 1 && cartGoods.isValid === 1" />
                    <van-button square text="删除" type="danger" style="height: 100%;;" @click="clickPop(cartGoods)" />
                  </template>
                </van-swipe-cell>
                <div class="gray_2 clear cartGift"
                  v-if="cartGoods.cartGiftGoodsResList && cartGoods.cartGiftGoodsResList.length > 0">
                  <div class="box5"></div>
                  <span class="mui-pull-left f10_rem pad8_r lin_20">套餐</span>
                  <div class="mui-pull-left mar3_t">
                    <p v-for="packageGoods in cartGoods.cartGiftGoodsResList" v-bind:key="packageGoods.goodsId">
                      <a class="gray_2" v-bind:href="
                          `/mob/goods/detail/` +
                            packageGoods.goodsId +
                            `?fromShopId=` +
                            cartGoods.shopIdStr
                        " v-show="packageGoods.isShow">
                        <span class="w120 inlineblock ellipsis ver_text_bottom f10_rem gray_9">
                          {{ packageGoods.goodsName }}
                        </span>
                        <i class="iconfont icon-gengduo"></i>
                      </a>
                    </p>
                    <span v-show="cartGoods.cartGiftGoodsResList.length > 2 && !cartGoods.giftMoreShow"
                      class="w120 inlineblock ellipsis ver_text_bottom f10_rem"
                      @click="showMoreGift(cartGoods)">展开查看套餐货品</span>
                    <span v-show="cartGoods.cartGiftGoodsResList.length > 2 && cartGoods.giftMoreShow"
                      class="w120 inlineblock ellipsis ver_text_bottom f10_rem"
                      @click="showMoreGift(cartGoods)">收起</span>
                  </div>
                </div>
                <div class="gray_2 text-right" style="opacity: 0.7;" v-if="
                    cartGoods.promotionEntityVo != null &&
                    cartGoods.promotionEntityVo.isPromotion==1 &&
                      cartGoods.promotionEntityVo.promotionTypeCN != null &&
                      cartGoods.promotionEntityVo.promotionTypeCN === '买赠'
                  ">
                  <div class="mar3_t flex justify-end" v-for="(item, index) in cartGoods.promotionEntityVo.giftList"
                    :key="index">
                    <a class="gray_2 flex-auto w0 pad10-lr  ellipsis" v-bind:href="
                          `/mob/goods/detail/` +
                          item.giftGoodsId +
                            `?fromShopId=` +
                            cartGoods.shopIdStr
                        ">
                      <span class="pad10-r">赠品</span>
                      {{ item.giftGoodsName }}
                    </a>
                    <i class="iconfont flex-shrink icon-gengduo"></i>
                  </div>
                  <div class="box5"></div>
                </div>
              </div>
            </li>
          </ul>
          <template v-if="disCartList.length">
            <div class="flex justify-between pad10-tb pad15-lr bg-white">
              <span>已失效商品</span>
              <span class="gray9" @click="emptyFailure">清空失效商品</span>
            </div>
            <ul class="good_list dis-good-list mar15-b">
              <li v-for="cartGoods in disCartList" v-bind:key="cartGoods.cgId">
                <van-swipe-cell>
                  <van-divider style="margin: 1px 15px" />
                  <div class="mui-slider-handle clear relative cart_good">
                    <div class="clear f10_rem lin_24" v-if="
                        cartGoods.promotionEntityVo != null &&
                          cartGoods.promotionEntityVo.promotionTypeCN != null
                      ">
                      <!-- <div class="float-left">
                        <span class="good_label b_red white">{{
                          cartGoods.promotionEntityVo.promotionTypeCN
                        }}</span> -->
                      <!-- <span
                          v-if="
                            cartGoods.promotionEntityVo.promotionTypeCN != null &&
                              cartGoods.promotionEntityVo.promotionTypeCN === '买赠'
                          "
                          >活动商品{{ cartGoods.promotionEntityVo.promotionName }}，每人最多领取{{
                            cartGoods.promotionEntityVo.promotionLimitation
                          }}件赠品</span
                        > -->
                      <!-- <span
                          v-if="
                            cartGoods.promotionEntityVo.promotionTypeCN != null &&
                              cartGoods.promotionEntityVo.promotionTypeCN != '集采'
                          "
                          >活动商品{{ cartGoods.promotionEntityVo.promotionName }}，每人限购{{
                            cartGoods.promotionEntityVo.promotionLimitation
                          }}件</span
                        >
                        <span v-else>活动商品正在进行集采</span> -->
                      <!-- </div> -->
                    </div>
                    <div class="box5"></div>
                    <div class="cart_good_lose">
                      <p>失效</p>
                    </div>
                    <div class="clear">
                      <div class="float-left" style="width: 25px; height: 100px;"></div>
                      <div class="float-left relative cart_good_img">
                        <van-image lazy-load :src="`${cartGoods.picUrl}?imageView2/1/w/200/h/200`"></van-image>
                        <div v-if="cartGoods.subscriptList && cartGoods.subscriptList.length"
                          class="absolute z-index2 goods-badge">
                          <img v-if="cartGoods.subscriptList[0].code == 'ZL_YH'"
                            src="https://nfs.nxin.com/cms_image_b7007a5b-168c-4e50-9721-eec66d6cf7e5.png" />
                          <img v-else-if="cartGoods.subscriptList[0].code == 'BP'"
                            src="https://nfs.nxin.com/cms_image_4a4b45d9-58b1-49b0-89ee-7a03f91b5225.png" />
                          <img v-else-if="cartGoods.subscriptList[0].code == 'YX'"
                            src="https://nfs.nxin.com/cms_image_b6ee03a9-cb9e-4023-8a72-63c85b4aff5a.png" />
                        </div>
                      </div>
                      <div class="float-left cart_good_main">
                        <p class="gray_2 ellipsis_two f14_rem lin_20">
                          <span class="cart_good_vip f10_rem" v-if="cartGoods.isVip === 1">VIP</span>
                          {{ cartGoods.goodsName }}
                        </p>
                        <div class="box5"></div>
                        <p class="f10_rem cart_good_spec" v-if="cartGoods.msUnit && cartGoods.msUnit.length > 0">
                          {{ cartGoods.unitConver }}{{ cartGoods.msUnit }}
                        </p>
                        <p class="f10_rem cart_good_spec" v-else>{{ cartGoods.goodsSpec }}</p>
                        <div class="box5"></div>
                      </div>
                    </div>
                    <div class="gray_2 f10_rem">
                      <div class="box10"></div>
                      <i class="iconfont icon-shibai red fb mar5_r"></i>
                      货品未上架、库存不足会导致货品失效
                    </div>
                  </div>
                  <template #right>
                    <van-button square text="删除" type="danger" style="height: 100%;;" @click="clickPop(cartGoods)" />
                  </template>
                </van-swipe-cell>
              </li>
            </ul>
          </template>
        </div>
        <div class="pad30"></div>
        <div>
          <div class="z_toPay to-border-t mui-clearfix b_white flex items-center" v-if="cartList.length > 0"
            v-show="!isEdit">
            <div class="mui-col-xs-3  mui-pull-left z_check all_check" :class="{ cur: isAllCheck }"
              @click="checkAllCart">
              全选
            </div>
            <div class="mui-col-xs-6 mui-pull-left">
              <p class="gray_2 f14 box30 lin_26">
                总计：<span class="red"><em class="f20_rem"><span class="f12 mar3-r fb">¥</span>{{
                    calculateGoodsPrice.goodsAmountAll
                    ? calculateGoodsPrice.goodsAmountAll.toString().split(".")[0]
                    : "0"
                    }}</em>.{{
                  calculateGoodsPrice.goodsAmountAll
                  ? calculateGoodsPrice.goodsAmountAll.toString().split(".")[1]
                  : "00"
                  }}</span>
              </p>
              <p class="gray_9 f10_rem" v-show="Number(calculateGoodsPrice.promotionPriceAll)">
                优惠：-￥{{ calculateGoodsPrice.promotionPriceAll }}
                <span class="offer_details" @click="showDiscount">优惠明细</span>
              </p>
              <p class="gray_9 f10_rem" v-show="Number(sendPlateBounty.sendAmountAll)">
                预计可获得返点奖励金：{{ sendPlateBounty.sendAmountAll }}
              </p>
            </div>
            <div class="mui-col-xs-3  mui-pull-left toPay_btn clear">
              <p class="f14 mui-text-center white b_red" @click="submitOrder">
                去结算({{ countCheckGoods }})
              </p>
            </div>
          </div>
          <div class="z_toPay mui-clearfix b_white z_delete flex items-center" v-show="isEdit" v-if="!isEmptyCart">
            <div class="mui-col-xs-3  mui-pull-left z_check all_check" :class="{ cur: isAllCheck }"
              @click="checkAllCart">
              全选
            </div>
            <div class="mui-col-xs-3 mui-pull-left pad10_td">
              <!-- <span class="f12_rem mui-text-center" @click="emptyFailure">清空失效商品</span> -->
            </div>
            <div class="mui-col-xs-6  mui-pull-left delete_btn clear">
              <span class="f13 relative t-1 mui-text-center gray_2 b_d2" @click="addCheckFavorite">移入收藏</span>
              <span class="f13 mui-text-center gray_2 bor_d2" @click="delCheck">删除</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mask"></div>
      <div class="mask_lucency"></div>
      <!--收藏-->
      <!--    <div class="collect_success t_center f12_rem">-->
      <!--      <img src="./images/collect_success.png" alt="">-->
      <!--      <p class="white">收藏成功</p>-->
      <!--    </div>-->
      <!--删除-->
      <div class="delete_success t_center f12_rem" v-show="isHint">
        <div class="clear">
          <van-image class="mui-pull-left good_img" :src="`${planDelCartGoods.picUrl}?imageView2/1/w/200/h/200`"
            lazy-load></van-image>
          <div class="mui-pull-left t_left">
            <p class="t_right">
              <i class="iconfont icon-guanbi white f12_rem" @click="closeDelete"></i>
            </p>
            <p class="f12_rem white">删除商品？</p>
            <div class="box5"></div>
            <p class="f12_rem white">您可以选择收藏或删除商品</p>
          </div>
        </div>
        <div class="t_center operation mar30_t">
          <span class="white bor_white" @click="delCart(planDelCartGoods.cgId)">删除</span>
          <span class="white b_red bor_red mar30_l" v-if="planDelCartGoods.isFavorite === 0"
            @click="addFavorite(planDelCartGoods)">收藏</span>
          <span class="white b_red bor_red mar30_l" v-if="planDelCartGoods.isFavorite === 1"
            @click="closeDelete">收藏</span>
        </div>
      </div>
      <div class=" b_white f18_rem cart_coupon_pop">
        <h1 class="gray_2 f18_rem t_center">优惠券</h1>
        <div class="cart_coupon_wrap">
          <p class="gray_2 mar10_b">您勾选的商品暂无优惠券可用，看看其他优惠券吧~</p>
          <div>
            <p class="gray_2 mar10_b">未勾选商品可用优惠券</p>
            <ul>
              <li class="clear">
                <div class="mui-pull-left coupon_left t_center">
                  <p class="white">￥<span class="f26_rem">30</span></p>
                  <p class="white f11_rem">满500可用</p>
                </div>
                <div class="mui-pull-left coupon_right">
                  <div class="mui-pull-left">
                    <p class="f12_rem gray_2">全部货品</p>
                    <div class="box20"></div>
                    <p class="f11_rem gray_9">2020.05.18 - 2020.06.28</p>
                  </div>
                  <span class="white b_red get_coupon mui-pull-right f12_rem t_center">立即领取</span>
                </div>
              </li>
              <li class="clear">
                <div class="mui-pull-left coupon_left t_center">
                  <p class="white">￥<span class="f26_rem">30</span></p>
                  <p class="white f11_rem">满500可用</p>
                </div>
                <div class="mui-pull-left coupon_right">
                  <div class="mui-pull-left">
                    <p class="f12_rem gray_2">全部货品</p>
                    <div class="box20"></div>
                    <p class="f11_rem gray_9">2020.05.18 - 2020.06.28</p>
                  </div>
                  <span class="white b_red get_coupon mui-pull-right f12_rem t_center">立即领取</span>
                </div>
              </li>
              <li class="clear">
                <div class="mui-pull-left coupon_left t_center">
                  <p class="white">￥<span class="f26_rem">30</span></p>
                  <p class="white f11_rem">满500可用</p>
                </div>
                <div class="mui-pull-left coupon_right">
                  <div class="mui-pull-left">
                    <p class="f12_rem gray_2">全部货品</p>
                    <div class="box20"></div>
                    <p class="f11_rem gray_9">2020.05.18 - 2020.06.28</p>
                  </div>
                  <span class="white b_red get_coupon mui-pull-right f12_rem t_center">立即领取</span>
                </div>
              </li>
              <li class="clear">
                <div class="mui-pull-left coupon_left t_center">
                  <p class="white">￥<span class="f26_rem">30</span></p>
                  <p class="white f11_rem">满500可用</p>
                </div>
                <div class="mui-pull-left coupon_right">
                  <div class="mui-pull-left">
                    <p class="f12_rem gray_2">全部货品</p>
                    <div class="box20"></div>
                    <p class="f11_rem gray_9">2020.05.18 - 2020.06.28</p>
                  </div>
                  <span class="white b_red get_coupon mui-pull-right f12_rem t_center">立即领取</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--eslint-disable-next-line-->
      <van-popup :style="{ height: '400px' }" position="bottom" round v-model:show="discountsShow">
        <div class=" b_white f18_rem offer_details_pop">
          <h1 class="gray_2 f18_rem t_center">优惠明细</h1>
          <ul class="gray_9">
            <li class="clear mar15_b">
              <span class="mui-pull-left">货品总额</span>
              <span class="mui-pull-right">¥{{ calculateGoodsPrice.goodsAmountAll }}</span>
            </li>
            <li class="clear" v-for="(item, index) in calculateGoodsPrice.promotionList" :key="index">
              <span class="mui-pull-left">{{ item.promotionTypeCn }}</span>
              <span class="mui-pull-right">-¥{{ item.promotionAmount }}</span>
            </li>
            <!-- <li class="clear" v-show="discounts.discountPrice > 0">
              <span class="mui-pull-left">折扣</span>
              <span class="mui-pull-right">-¥{{ discounts.discountPrice }}</span>
            </li>
            <li class="clear" v-show="discounts.sellingPrice > 0">
              <span class="mui-pull-left">直降</span>
              <span class="mui-pull-right">-¥{{ discounts.sellingPrice }}</span>
            </li>
            <li class="clear" v-show="discounts.groupPrice > 0">
              <span class="mui-pull-left">集采</span>
              <span class="mui-pull-right">-¥{{ discounts.groupPrice }}</span>
            </li>
            <li class="clear" v-show="discounts.vipPrice > 0">
              <span class="mui-pull-left">VIP</span>
              <span class="mui-pull-right">-¥{{ discounts.vipPrice }}</span>
            </li>
            <li class="clear" v-show="discounts.laddersPrice > 0">
              <span class="mui-pull-left">阶梯</span>
              <span class="mui-pull-right">-¥{{ discounts.laddersPrice }}</span>
            </li> -->
            <li class="clear">
              <div class="mui-pull-left">
                <p>共优惠(不包含运费)</p>
              </div>
              <span class="mui-pull-right red">-¥{{ calculateGoodsPrice.promotionPriceAll }}</span>
            </li>
          </ul>
        </div>
      </van-popup>
      <!--eslint-disable-next-line-->
      <van-dialog v-model:show="quantityShow" title="修改购买数量" show-cancel-button showConfirmButton
        style="text-align: center" @confirm="editQuantityDoBefore(quantityCartGoods, 0)">
        <div class="box10"></div>
        <van-stepper v-if="quantityCartGoods.goodsDigit === 0" integer v-model="quantityCartGoods.goodsQuantity"
          :min="0" :max="99999999" input-width="100px" button-size="40px" @blur="formatNum" />
        <van-stepper v-else-if="quantityCartGoods.goodsDigit === 2" v-model="quantityCartGoods.goodsQuantity" :min="0"
          :max="99999999" :decimal-length="2" input-width="100px" button-size="40px" @blur="formatNum" />
        <van-stepper v-else v-model="quantityCartGoods.goodsQuantity" :min="0" :max="99999999" :decimal-length="4"
          input-width="100px" button-size="40px" @blur="formatNum" />
        <div class="box10"></div>
      </van-dialog>
    </div>
  </van-pull-refresh>
</template>

<style>
  .van-swipe-cell__right {
    right: -4px;
  }
</style>

<style lang="scss" scoped>
  @import "./style.scss";
</style>
<script>
  import { mapState } from "vuex";
  import { Dialog, Toast } from "vant";
  import common from "../../assets/js/common";
  import requestApi from "@/utils/requestApi";

  export default {
    name: "Cart",
    data() {
      return {
        refreshLoading: false,
        isEmptyCart: false, // 是否空进货车
        cartGoodsNum: 10,
        userName: "个人", // 当前身份
        cartList: [], // 进货车数据
        discountsShow: false, // 优惠提示
        isEdit: false, // 是否在编辑
        isHint: false, // 是否弹出删除提示
        planDelCartGoods: {}, // 计划删除的进货车数据
        isAllCheck: false,
        checkSumMoney: "0.00", // 总选中商品金额
        discountsMoney: 0, // 总优惠金额
        discounts: {}, // 价格优惠详情
        countCheckGoods: 0, // 总选中商品数量
        isSubmit: true,
        quantityShow: false, // 修改数量弹框
        quantityCartGoods: {}, // 修改数量进货车
        retUrl: "",

        disCartList: [], // 失效商品,
        ajaxCartList: [],
        taaspublicLink: process.env.VUE_APP_taaspublic,
        calculateGoodsPrice: {}, // 后台返回商品计算属性
        // 预计发放奖励金
        sendPlateBounty: {}
      };
    },
    computed: mapState({
      userInfo: state => state.app.userInfo
    }),
    created() {
      console.log("this.$store", this.$store);
      const { retUrl } = this.$route.query;
      console.log("retUrl", retUrl);
      this.retUrl = retUrl;
      Toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });
      this.downLoadCart();
    },
    methods: {
      // 弹框数量修改
      formatNum() {
        const { minOrderQuantity, goodsQuantity } = this.quantityCartGoods;
        if (
          minOrderQuantity &&
          minOrderQuantity > 1 &&
          Number(goodsQuantity) < Number(minOrderQuantity)
        ) {
          Toast("不可少于最低起订量，请重新输入");
        }
      },
      // 加载进货车列表
      downLoadCart() {
        this.$store.dispatch("cart/cart/getCart", {}).then(async data => {
          Toast.clear();
          this.refreshLoading = false;
          if (data == null || data.cartList == null) {
            this.isEmptyCart = true;
            return;
          }
          this.isAllCheck = false;
          this.cartGoodsNum = data.cartGoodsNum;
          data.cartList.forEach(cart => {
            this.$set(cart, "isCheck", false);
            cart.shopCartGoods.forEach(cartGoods => {
              const { goodsPriceEntity } = cartGoods;
              cartGoods.sellFactPriceStrOld = JSON.parse(JSON.stringify(cartGoods.sellFactPriceStr));
              if (cartGoods.minOrderQuantity > 1) {
                cartGoods.goodsQuantity = cartGoods.minOrderQuantity;
              }
              if (
                cartGoods.goodsPriceEntity &&
                cartGoods.goodsPriceEntity.commonLaddersPrice &&
                cartGoods.goodsPriceEntity.commonLaddersPrice.goodsPriceList &&
                cartGoods.goodsPriceEntity.commonLaddersPrice.goodsPriceList.length
              ) {
                let { goodsPriceList } = JSON.parse(
                  JSON.stringify(cartGoods.goodsPriceEntity.commonLaddersPrice)
                );
                goodsPriceList = goodsPriceList.reverse();
                const filter = goodsPriceList.filter(
                  item => Number(cartGoods.goodsQuantity) >= Number(item.minQuantity)
                )[0];
                if (filter) {
                  cartGoods.sellFactPrice = Number(filter.price);
                  cartGoods.sellFactPriceStr = filter.price;
                }
              }
              if (goodsPriceEntity) {
                const { memberGoodsPriceProgrammeVo } = goodsPriceEntity;
                if (memberGoodsPriceProgrammeVo) {
                  this.$set(
                    cartGoods,
                    "goodsPriceMemberLevel",
                    memberGoodsPriceProgrammeVo.memberLevel || ""
                  );
                }
              }
              this.$set(cartGoods, "isCheck", false);
              if (
                cartGoods.cartGiftGoodsResList &&
                cartGoods.cartGiftGoodsResList !== null &&
                cartGoods.cartGiftGoodsResList.length > 0
              ) {
                if (cartGoods.cartGiftGoodsResList.length > 2) {
                  this.$set(cartGoods, "giftMoreShow", false);
                }
                for (let i = 0; i < cartGoods.cartGiftGoodsResList.length; i += 1) {
                  if (i < 2) {
                    this.$set(cartGoods.cartGiftGoodsResList[i], "isShow", true);
                  } else {
                    this.$set(cartGoods.cartGiftGoodsResList[i], "isShow", false);
                  }
                }
              }
            });
          });

          this.userName = data.userName;
          this.cartList = [];
          this.disCartList = [];
          data.cartList.forEach(item => {
            const shopCartGoods = item.shopCartGoods.filter(item1 => item1.isValid === 1);
            const disShopCartGoods = item.shopCartGoods.filter(item1 => item1.isValid === 0);
            if (shopCartGoods.length) {
              this.cartList.push({
                ...item,
                shopCartGoods
              });
            }
            this.disCartList = this.disCartList.concat(disShopCartGoods);
          });
          console.log("disCartList", this.disCartList);

          const { data: data2, code, msg } = await requestApi.post(
            "/sctrading/price/goods/calculateGoodsPrice",
            { cartList: this.ajaxCartList }
          );
          if (code == "0") {
            this.calculateGoodsPrice = data2;
            const { cartList } = data2;
            this.cartList.forEach(cartListItem => {
              cartListItem.shopCartGoods.forEach(goodsItem => {
                const findIndex = cartList.findIndex(findItem => findItem.skuId == goodsItem.goodsId);
                if (findIndex != -1) {
                  goodsItem.sellFactPriceStr = cartList[findIndex].currPrice;
                }
              });
            });
          } else {
            Toast(msg);
            this.calculateGoodsPrice = {};
          }
        });
      },
      // 展示更多套餐商品
      showMoreGift(cartGoods) {
        const moreShow = !cartGoods.giftMoreShow;
        this.$set(cartGoods, "giftMoreShow", moreShow);
        for (let i = 0; i < cartGoods.cartGiftGoodsResList.length; i += 1) {
          if (i >= 2) {
            this.$set(cartGoods.cartGiftGoodsResList[i], "isShow", moreShow);
          }
        }
      },
      // 删除进货车
      delCart(cgId) {
        this.$store
          .dispatch("cart/cart/delCart", {
            ids: cgId
          })
          .then(res => {
            Toast(res.msg);
            this.isHint = false;
            this.downLoadCart();
          });
      },

      editQuantityDoBefore(cartGoods, flag) {
        console.log("editQuantityDoBefore.....");
        // 最小起订量
        const minOrderQuantity = cartGoods.minOrderQuantity && cartGoods.minOrderQuantity > 1
          ? cartGoods.minOrderQuantity
          : 0.0001;
        // 数量变化前的值
        const preGoodsQuantity = cartGoods.prevGoodsQuantity;
        console.log("preGoodsQuantity", preGoodsQuantity);
        this.$nextTick(() => {
          if (cartGoods.goodsQuantity < minOrderQuantity && preGoodsQuantity > cartGoods.goodsQuantity) {
            // 恢复 van-stepper 加减前的值
            this.planDelCartGoods = cartGoods;
            this.isHint = true;
            cartGoods.goodsQuantity = preGoodsQuantity;
            return;
          }
          cartGoods.prevGoodsQuantity = cartGoods.goodsQuantity;
          this.editQuantity(cartGoods, flag);
        });
      },
      // 修改数量
      editQuantity(cartGoods, flag) {
        if (cartGoods.goodsDigit !== 0) {
          if (cartGoods.goodsQuantity < 0.0001) {
            Toast("请输入正确数量");
            return;
          }
          const indexOf = cartGoods.goodsQuantity.toString().indexOf(".");
          if (indexOf > 0) {
            if (
              cartGoods.goodsDigit === 2 &&
              cartGoods.goodsQuantity.toString().split(".")[1].length > cartGoods.goodsDigit
            ) {
              Toast(`商品数量只支持${cartGoods.goodsDigit}位小数`);
              return;
            }
            if (
              cartGoods.goodsDigit > 2 &&
              cartGoods.goodsQuantity.toString().split(".")[1].length > 4
            ) {
              Toast("商品数量最多可支持4位小数");
              return;
            }
          } else if (indexOf === 0) {
            Toast("请输入正确数量");
            return;
          }
        }
        if (cartGoods.goodsQuantity <= 0) {
          Toast("请输入正确数量");
          return;
        }

        this.$nextTick(() => {
          if (
            cartGoods.goodsPriceEntity &&
            cartGoods.goodsPriceEntity.commonLaddersPrice &&
            cartGoods.goodsPriceEntity.commonLaddersPrice.goodsPriceList &&
            cartGoods.goodsPriceEntity.commonLaddersPrice.goodsPriceList.length
          ) {
            let { goodsPriceList } = JSON.parse(
              JSON.stringify(cartGoods.goodsPriceEntity.commonLaddersPrice)
            );
            goodsPriceList = goodsPriceList.reverse();
            const filter = goodsPriceList.filter(
              item => Number(cartGoods.goodsQuantity) >= Number(item.minQuantity)
            )[0];
            console.log("filter", filter);
            // if (filter) {
            //   cartGoods.sellFactPrice = Number(filter.price);
            //   cartGoods.sellFactPriceStr = filter.price;
            // } else {
            //   cartGoods.sellFactPrice = Number(cartGoods.sellFactPriceStrOld);
            //   cartGoods.sellFactPriceStr = cartGoods.sellFactPriceStrOld;
            // }
          }

          this.$store
            .dispatch("cart/cart/editQuantity", {
              cgId: cartGoods.cgId,
              goodsId: cartGoods.goodsId,
              goodsQuantity: cartGoods.goodsQuantity
            })
            .then(res => {
              if (res.code === "0") {
                this.cartList.forEach(cart => {
                  cart.shopCartGoods.forEach(cGoods => {
                    if (cGoods.cgId === cartGoods.cgId) {
                      this.$set(cGoods, "goodsQuantity", cartGoods.goodsQuantity);

                      if (
                        cGoods.goodsPriceEntity &&
                        cGoods.goodsPriceEntity.commonLaddersPrice &&
                        cGoods.goodsPriceEntity.commonLaddersPrice.goodsPriceList &&
                        cGoods.goodsPriceEntity.commonLaddersPrice.goodsPriceList.length
                      ) {
                        this.$set(
                          cGoods.goodsPriceEntity.commonLaddersPrice,
                          "laddersPriceMsg",
                          res.data
                        );
                      }
                    }
                  });
                });
                this.computeCart();
              } else {
                Toast(res.msg);
                if (flag === 1) {
                  cartGoods.goodsQuantity -= 1;
                }
              }
            });
        });
      },
      // 修改商品数量弹窗
      popQuantity(cartGoods, e) {
        this.quantityShow = true;
        const cart = {
          cgId: cartGoods.cgId,
          goodsId: cartGoods.goodsId,
          goodsQuantity: cartGoods.goodsQuantity,
          goodsDigit: cartGoods.goodsDigit,
          minOrderQuantity: cartGoods.minOrderQuantity || 1,
          prevGoodsQuantity: cartGoods.goodsQuantity,
          picUrl: cartGoods.picUrl,
          isFavorite: cartGoods.isFavorite
        };
        this.quantityCartGoods = cart;
        e.target.blur();
      },
      // +商品数量
      plusQuantity(cartGoods) {
        this.editQuantity(cartGoods, 1);
      },
      // -商品数量
      minusQuantity(cartGoods) {
        console.log("minusQuantity.....");
        // 最小起订量
        const minOrderQuantity = cartGoods.minOrderQuantity && cartGoods.minOrderQuantity > 1
          ? cartGoods.minOrderQuantity
          : 0.0001;
        // 数量变化前的值
        const preGoodsQuantity = cartGoods.goodsQuantity;
        console.log("preGoodsQuantity", preGoodsQuantity);
        this.$nextTick(() => {
          if (cartGoods.goodsQuantity < minOrderQuantity) {
            // 恢复 van-stepper 加减前的值
            this.planDelCartGoods = cartGoods;
            this.isHint = true;
            cartGoods.goodsQuantity = preGoodsQuantity;
            return;
          }
          this.editQuantity(cartGoods, 2);
        });
      },
      // 弹出修改商品弹窗
      clickPop(cartGoods) {
        this.planDelCartGoods = cartGoods;
        this.isHint = true;
      },
      // 关闭删除弹窗
      closeDelete() {
        this.isHint = false;
      },
      // 添加收藏
      addFavorite(cartGoods) {
        const memberFavoriteArr = [
          {
            type: 1,
            resId: cartGoods.goodsId,
            shopId: cartGoods.shopIdStr
          }
        ];
        this.$store
          .dispatch("member/member/addFavorite", {
            json: encodeURIComponent(JSON.stringify(memberFavoriteArr))
          })
          .then(res => {
            Toast({
              message: "收藏成功",
              icon: "passed"
            });
            if (res.code === "0") {
              this.$set(cartGoods, "isFavorite", 1);
              this.isHint = false;
            }
            this.downLoadCart();
          });
      },
      // 删除收藏
      delFavorite(cartGoods) {
        this.$store
          .dispatch("member/member/delFavorite", {
            ids: cartGoods.favoriteId
          })
          .then(res => {
            Toast({
              message: res.msg,
              icon: "passed"
            });
            if (res.code === "0") {
              this.$set(cartGoods, "isFavorite", 0);
              this.$set(cartGoods, "favoriteId", "");
            }
          });
      },
      // 是否编辑
      editCart() {
        this.isEdit = !this.isEdit;
      },
      // 单选店铺
      checkShop(cart) {
        this.$set(cart, "isCheck", !cart.isCheck);
        if (cart.isCheck) {
          cart.shopCartGoods.forEach(cartGoods => {
            if (cartGoods.isValid === 1) {
              this.$set(cartGoods, "isCheck", true);
            }
          });
          let isAllCheck = true;
          this.cartList.forEach(c => {
            if (!c.isCheck) {
              isAllCheck = false;
            }
          });
          this.isAllCheck = isAllCheck;
        } else {
          cart.shopCartGoods.forEach(cartGoods => {
            if (cartGoods.isValid === 1) {
              this.$set(cartGoods, "isCheck", false);
            }
          });
          this.isAllCheck = cart.isCheck;
        }
        this.computeCart();
      },
      // 单选商品
      checkGoods(cart, cartGoods) {
        this.$set(cartGoods, "isCheck", !cartGoods.isCheck);
        if (cartGoods.isCheck) {
          let cartIsCheck = true;
          cart.shopCartGoods.forEach(goods => {
            if (!goods.isCheck && goods.isValid === 1) {
              cartIsCheck = false;
            }
          });
          this.$set(cart, "isCheck", cartIsCheck);
          let isAllCheck = true;
          this.cartList.forEach(c => {
            if (!c.isCheck) {
              isAllCheck = false;
            }
          });
          this.isAllCheck = isAllCheck;
        } else {
          this.$set(cart, "isCheck", false);
          this.isAllCheck = false;
        }
        this.computeCart();
      },
      // 全选
      checkAllCart() {
        this.isAllCheck = !this.isAllCheck;
        this.cartList.forEach(cart => {
          this.$set(cart, "isCheck", this.isAllCheck);
          cart.shopCartGoods.forEach(cartGoods => {
            if (cartGoods.isValid === 1) {
              this.$set(cartGoods, "isCheck", this.isAllCheck);
            }
          });
        });
        this.computeCart();
      },
      // 选中的添加收藏
      addCheckFavorite() {
        const checkCart = [];
        const favoriteJson = [];
        let checkNum = 0;
        this.cartList.forEach(cart => {
          cart.shopCartGoods.forEach(cartGoods => {
            if (cartGoods.isCheck) {
              checkCart.push(cartGoods);
            }
          });
        });
        if (checkCart.length === 0) {
          Toast("请先选择货品");
          return;
        }
        this.cartList.forEach(cart => {
          cart.shopCartGoods.forEach(cartGoods => {
            if (cartGoods.isCheck && cartGoods.isFavorite === 0) {
              const favorite = {
                type: 1,
                resId: cartGoods.goodsId,
                shopId: cartGoods.shopIdStr
              };
              favoriteJson.push(favorite);
              checkNum += 1;
            }
          });
        });
        if (checkNum === 0) {
          Toast("添加成功");
          return;
        }
        this.$store
          .dispatch("member/member/addFavorite", {
            json: encodeURIComponent(JSON.stringify(favoriteJson))
          })
          .then(res => {
            Toast(res.msg);
            favoriteJson.forEach(cartGoods => {
              this.$set(cartGoods, "isFavorite", 1);
            });
            this.downLoadCart();
          });
      },
      // 删除所有选中
      delCheck() {
        let ids = "";
        let idNum = 0;
        this.cartList.forEach(cart => {
          cart.shopCartGoods.forEach(cartGoods => {
            if (cartGoods.isCheck) {
              ids += `${cartGoods.cgId},`;
              idNum += 1;
            }
          });
        });
        const number = ids.lastIndexOf(",");
        if (idNum === 0) {
          Toast("请先选择货品");
          return;
        }
        ids = ids.substring(0, number);
        Dialog.confirm({
          title: "确认删除",
          message: `确认要删除这${idNum}种商品吗？`
        })
          .then(() => {
            this.$store
              .dispatch("cart/cart/delCart", {
                ids
              })
              .then(res => {
                Toast(res.msg);
                this.downLoadCart();
              });
            this.isHint = false;
          })
          .catch(() => {
            this.isHint = false;
          });
        this.computeCart();
      },
      // 计算金额
      async computeCart() {
        console.log("this.cartList", this.cartList);
        let sumMoney = 0;
        let discountsMoney = 0;
        const discounts = {
          discountPrice: 0,
          sellingPrice: 0,
          groupPrice: 0,
          vipPrice: 0,
          laddersPrice: 0
        };
        let checkGoodsNum = 0;
        const ajaxCartList = [];
        this.cartList.forEach(cart => {
          cart.shopCartGoods.forEach(cartGoods => {
            if (cartGoods.isCheck && cartGoods.sellFactPrice != null) {
              ajaxCartList.push({
                skuId: cartGoods.goodsId,
                quantity: cartGoods.goodsQuantity
              });
              let unitConver = 1;
              if (cartGoods.msUnit && cartGoods.msUnit.length > 0) {
                unitConver = cartGoods.unitConver; //eslint-disable-line
              }
              checkGoodsNum += 1;
              const factPrice = parseFloat(
                (cartGoods.goodsQuantity * cartGoods.sellFactPrice * unitConver).toFixed(2)
              );
              sumMoney += factPrice;
              let sellPrice = 0;
              if (cartGoods.sellPrice != null) {
                sellPrice = parseFloat(
                  (cartGoods.goodsQuantity * cartGoods.sellPrice * unitConver).toFixed(2)
                );
                discountsMoney += sellPrice - factPrice;
              }
              if (
                cartGoods.promotionEntityVo != null &&
                cartGoods.promotionEntityVo.activeState === "HAVE_IN_HAND"
              ) {
                // 计算促销活动优惠金额
                if (cartGoods.promotionEntityVo.promotionType === "DISCOUNT") {
                  // 折扣
                  discounts.discountPrice += parseFloat(sellPrice - factPrice);
                  discounts.discountPrice = parseFloat(discounts.discountPrice.toFixed(2));
                } else if (cartGoods.promotionEntityVo.promotionType === "DIRECT_SELLING") {
                  // 直降
                  discounts.sellingPrice += parseFloat(sellPrice - factPrice);
                  discounts.sellingPrice = parseFloat(discounts.sellingPrice.toFixed(2));
                } else if (cartGoods.promotionEntityVo.promotionType === "GROUP_PURCHASE") {
                  // 集采
                  discounts.groupPrice += parseFloat(sellPrice - factPrice);
                  discounts.groupPrice = parseFloat(discounts.groupPrice.toFixed(2));
                }
              }
              if (cartGoods.isVip === 1) {
                // vip
                discounts.vipPrice += parseFloat(sellPrice - factPrice);
                discounts.vipPrice = parseFloat(discounts.vipPrice.toFixed(2));
              }
              // 阶梯价
              if (
                cartGoods.goodsPriceEntity &&
                cartGoods.goodsPriceEntity.commonLaddersPrice &&
                cartGoods.goodsPriceEntity.commonLaddersPrice.goodsPriceList &&
                cartGoods.goodsPriceEntity.commonLaddersPrice.goodsPriceList.length
              ) {
                let { goodsPriceList } = JSON.parse(
                  JSON.stringify(cartGoods.goodsPriceEntity.commonLaddersPrice)
                );
                goodsPriceList = goodsPriceList.reverse();
                const filter = goodsPriceList.filter(
                  item => Number(cartGoods.goodsQuantity) >= Number(item.minQuantity)
                )[0];
                if (filter) {
                  discounts.laddersPrice += parseFloat(sellPrice - factPrice);
                  discounts.laddersPrice = parseFloat(discounts.laddersPrice.toFixed(2));
                }
              }
            }
          });
        });

        this.ajaxCartList = ajaxCartList;

        this.countCheckGoods = checkGoodsNum;
        this.checkSumMoney = this.keepTwoDecimalFull(sumMoney);
        this.discountsMoney = this.keepTwoDecimalFull(discountsMoney);
        this.discounts = discounts;

        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 0
        });
        const { data, code, msg } = await requestApi.post(
          "/sctrading/price/goods/calculateGoodsPrice",
          { cartList: ajaxCartList }
        );
        if (code == "0") {
          this.calculateGoodsPrice = data;
          const { cartList } = data;
          this.cartList.forEach(cartListItem => {
            cartListItem.shopCartGoods.forEach(goodsItem => {
              const findIndex = cartList.findIndex(findItem => findItem.skuId == goodsItem.goodsId);
              if (findIndex != -1) {
                goodsItem.sellFactPriceStr = cartList[findIndex].currPrice;
              }
            });
          });
          await this.getBountyPrepareData();
        } else {
          Toast(msg);
          this.calculateGoodsPrice = {};
        }
        Toast.clear();
      },

      // 查询可发放奖励金
      async getBountyPrepareData() {
        const busDataList = [];
        this.cartList.forEach(cartListItem => {
          cartListItem.shopCartGoods.forEach(goodsItem => {
            if (goodsItem.isCheck && goodsItem.sellFactPrice != null) {
              const busData = {};
              busData.skuId = goodsItem.goodsId;
              busData.amount = goodsItem.goodsQuantity;
              busData.goodsPayMoney = parseFloat(
                (goodsItem.goodsQuantity * goodsItem.sellFactPrice).toFixed(2)
              );
              busDataList.push(busData);
            }
          });
        });
        if (!busDataList) {
          return;
        }
        const { data, code } = await requestApi.post(
          "/sctrading/plate/bounty/send/selectPrepareData",
          { busDataList }
        );
        if (code == "0" && data && data.sendAmountAll) {
          this.sendPlateBounty = data;
        } else {
          this.sendPlateBounty = {};
        }
      },
      // 金额展示优化
      keepTwoDecimalFull(num) {
        let result = parseFloat(num);
        result = Math.round(num * 100) / 100;
        let sum = result.toString(); // 将数字转换为字符串
        let posDecimal = sum.indexOf("."); // 小数点的索引值
        // 当整数时，pos_decimal=-1 自动补0
        if (posDecimal < 0) {
          posDecimal = sum.length;
          sum += ".";
        }
        // 当数字的长度< 小数点索引+2时，补0
        while (sum.length <= posDecimal + 2) {
          sum += "0";
        }
        return sum;
      },
      // 展示优惠提示
      showDiscount() {
        this.discountsShow = true;
      },
      // 清空失效
      emptyFailure() {
        let ids = "";
        const disGoodIdList = this.disCartList.map(item => item.cgId);
        ids = disGoodIdList.toString();
        this.$store
          .dispatch("cart/cart/delCart", {
            ids
          })
          .then(res => {
            Toast(res.msg);
            this.downLoadCart();
          });
      },
      // 购买跳转订单提交页
      submitOrder() {
        let ids = "";
        let idNum = 0;
        // 是否包含应用市场商品
        let markGoodsNum = 0;
        let markGoodsName = "";
        const orderCart = [];
        this.cartList.forEach(cart => {
          cart.shopCartGoods.forEach(cartGoods => {
            if (cartGoods.isCheck) {
              if (cartGoods.axisStr && cartGoods.axisStr.indexOf("$4616$") > -1) {
                markGoodsNum += 1;
                markGoodsName = cartGoods.goodsName;
                return;
              }
              const oc = {
                // cgId: cartGoods.cgId,
                // goodsId: cartGoods.goodsId,
                // goodsQuantity: cartGoods.goodsQuantity,
                // fromShopId: cartGoods.shopIdStr,
                // fundShopId: cartGoods.fundShopIdStr,
                // fromCart: 1,
                shareBoId: cartGoods.shareBoId,
                skuId: cartGoods.goodsId,
                quantity: cartGoods.goodsQuantity,
                fromShopId: cartGoods.shopIdStr
              };
              orderCart.push(oc);
              ids += `${cartGoods.cgId},`;
              idNum += 1;
            }
          });
        });
        const number = ids.lastIndexOf(",");
        if (markGoodsNum != 0) {
          Toast(`商品${markGoodsName}无法在购物车中结算，请在商品详情页直接购买`);
          return;
        }
        if (idNum === 0) {
          Toast("请先选择要购买的商品");
          return;
        }
        if (!this.isSubmit) {
          Toast("请勿重复提交");
          setTimeout(() => {
            this.isSubmit = true;
          }, 500);
          return;
        }
        this.isSubmit = false;
        ids = ids.substring(0, number);
        const paramInfo = { cartItemReqFormList: orderCart };
        const uuid = common.guid();
        localStorage.setItem(uuid, `${JSON.stringify(paramInfo)}`);
        // sources -来源 0：进货车，2：再次购买，4：立即购买；3：代下单来源
        window.location.href = `${process.env.VUE_APP_APP
          }vm2/order/buyer/orderSubmit/index?subkey=${uuid}&sources=0`;
        // this.$store.dispatch("cart/cart/submitVerify", {
        //   cgIds: ids
        // }).then((res) => {
        //   if (!res.data.isSubmit) {
        //     Toast(res.data.msg);
        //     this.isSubmit = true;
        //   } else {
        //     const carts = encodeURIComponent(JSON.stringify(orderCart));
        //     this.isSubmit = true;
        //     window.location.href = `${process.env.VUE_APP_APP}mob/order/confirmOrder.do?sources=0&isGoodsByCart=1&carts=${carts}`;
        //   }
        // });
      },
      toWxIndex() {
        // com.nxin.heze
        const ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          //eslint-disable-line
          wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
              // 小程序
              wx.miniProgram.reLaunch({ url: "/pages/index/index" });
            } else {
              const url = this.retUrl ? this.retUrl : `${process.env.VUE_APP_APP}`;
              window.location.href = url;
            }
          });
        } else {
          const hzUrl = `${process.env.VUE_APP_APP}vm/sd/index`;
          if (ua.indexOf("com.nxin.heze") !== -1) {
            window.location.href = hzUrl;
            return;
          }
          if (isInZnt() && getZntVersion() >= "5.30") {
            window.location.href =
              "nxinznt://zhinongtong/p?action=eyJuZWVkTG9naW4iOmZhbHNlLCJwYWdlQ29kZSI6InBhZ2VfYXBwX21haW4iLCJtYWluVGFiIjoibWFsbFRhYiJ9";
          }
          const url = this.retUrl ? this.retUrl : `${process.env.VUE_APP_APP}`;
          window.location.href = url;
        }
      },
      onRefresh() {
        this.checkSumMoney = "0.00";
        this.countCheckGoods = 0;
        this.ajaxCartList = [];
        this.downLoadCart();
      },
      // 商品数量修改
      quantityChange(cartGoods) {
        cartGoods.isCheck = true;
      }
    }
  };
</script>